var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-page-array-editor"
  }, [_vm._l(_vm.pageItems, function (page, index) {
    return _c('div', {
      key: page.pageKey,
      staticClass: "page-item mb-4"
    }, [_c('div', {
      staticClass: "page-header d-flex align-items-center mb-3 pb-2"
    }, [_c('span', {
      staticClass: "page-order badge badge-primary mr-2"
    }, [_vm._v(_vm._s(index + 1))]), _c('span', {
      staticClass: "page-key-label flex-grow-1"
    }, [_vm._v(_vm._s(page.pageKey))]), _c('div', {
      staticClass: "page-actions d-flex flex-shrink-0 ml-3"
    }, [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm",
        "title": "刪除此頁面"
      },
      on: {
        "click": function click($event) {
          return _vm.confirmRemovePage(page.pageKey);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-delete"
    })])], 1)]), _c('div', {
      staticClass: "page-meta mb-3"
    }, [_c('b-form-row', _vm._l(page.metaFields, function (field) {
      return _c('b-col', {
        key: field.key,
        staticClass: "mb-2",
        attrs: {
          "cols": "12"
        }
      }, [_c('b-form-group', {
        staticClass: "mb-0",
        attrs: {
          "label-cols": "12",
          "label-cols-lg": "3",
          "label-size": "sm",
          "label": field.label,
          "label-class": "page-meta-label py-1"
        }
      }, [field.type === 'boolean' ? _c('b-form-checkbox', {
        staticClass: "pt-1",
        attrs: {
          "value": true,
          "unchecked-value": false
        },
        model: {
          value: _vm.form[_vm.fullKey(page.pageKey, field.key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, _vm.fullKey(page.pageKey, field.key), $$v);
          },
          expression: "form[fullKey(page.pageKey, field.key)]"
        }
      }) : _c('b-form-input', {
        attrs: {
          "size": "sm",
          "placeholder": field.placeholder || ''
        },
        model: {
          value: _vm.form[_vm.fullKey(page.pageKey, field.key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, _vm.fullKey(page.pageKey, field.key), $$v);
          },
          expression: "form[fullKey(page.pageKey, field.key)]"
        }
      })], 1)], 1);
    }), 1)], 1), _c('div', {
      staticClass: "page-menu mb-3"
    }, [_c('div', {
      staticClass: "page-meta-label mb-1"
    }, [_vm._v("頁面選單")]), _vm._l(_vm.pageMenusFor(page.pageKey), function (menuItem, menuIndex) {
      return _c('div', {
        key: 'menu-' + page.pageKey + '-' + menuIndex,
        staticClass: "page-menu-item mb-3"
      }, [_c('div', {
        staticClass: "page-menu-header d-flex align-items-center mb-2"
      }, [_c('span', {
        staticClass: "badge badge-primary mr-2"
      }, [_vm._v(_vm._s(menuIndex + 1))]), _c('b-form-input', {
        staticClass: "flex-grow-1 page-menu-title-input",
        attrs: {
          "placeholder": "請輸入選單標題",
          "size": "sm"
        },
        on: {
          "input": function input($event) {
            return _vm.persistPageMenus(page.pageKey);
          }
        },
        model: {
          value: menuItem.title,
          callback: function callback($$v) {
            _vm.$set(menuItem, "title", $$v);
          },
          expression: "menuItem.title"
        }
      }), _c('div', {
        staticClass: "page-menu-actions d-flex flex-shrink-0 ml-2"
      }, [menuIndex > 0 ? _c('b-button', {
        staticClass: "mr-1",
        attrs: {
          "variant": "outline-secondary",
          "size": "sm",
          "title": "上移"
        },
        on: {
          "click": function click($event) {
            return _vm.movePageMenuUp(page.pageKey, menuIndex);
          }
        }
      }, [_c('i', {
        staticClass: "mdi mdi-arrow-up"
      })]) : _vm._e(), menuIndex < _vm.pageMenusFor(page.pageKey).length - 1 ? _c('b-button', {
        staticClass: "mr-1",
        attrs: {
          "variant": "outline-secondary",
          "size": "sm",
          "title": "下移"
        },
        on: {
          "click": function click($event) {
            return _vm.movePageMenuDown(page.pageKey, menuIndex);
          }
        }
      }, [_c('i', {
        staticClass: "mdi mdi-arrow-down"
      })]) : _vm._e(), _c('b-button', {
        attrs: {
          "variant": "outline-danger",
          "size": "sm",
          "title": "刪除此選單項目"
        },
        on: {
          "click": function click($event) {
            return _vm.removePageMenuItem(page.pageKey, menuIndex);
          }
        }
      }, [_c('i', {
        staticClass: "mdi mdi-delete"
      })])], 1)], 1), _c('div', {
        staticClass: "page-menu-meta"
      }, [_c('b-form-row', [_c('b-col', {
        attrs: {
          "cols": "12",
          "lg": "8"
        }
      }, [_c('b-form-group', {
        staticClass: "mb-0",
        attrs: {
          "label": "網址",
          "label-size": "sm",
          "label-class": "page-menu-meta-label mb-1"
        }
      }, [_c('b-form-input', {
        attrs: {
          "size": "sm",
          "placeholder": "https://..."
        },
        on: {
          "input": function input($event) {
            return _vm.persistPageMenus(page.pageKey);
          }
        },
        model: {
          value: menuItem.url,
          callback: function callback($$v) {
            _vm.$set(menuItem, "url", $$v);
          },
          expression: "menuItem.url"
        }
      })], 1)], 1), _c('b-col', {
        attrs: {
          "cols": "12",
          "lg": "2"
        }
      }, [_c('b-form-group', {
        staticClass: "mb-0",
        attrs: {
          "label": "hashtag",
          "label-size": "sm",
          "label-class": "page-menu-meta-label mb-1"
        }
      }, [_c('b-form-input', {
        attrs: {
          "size": "sm",
          "placeholder": "開頭的 # 不需輸入"
        },
        on: {
          "input": function input($event) {
            return _vm.persistPageMenus(page.pageKey);
          }
        },
        model: {
          value: menuItem.hashtag,
          callback: function callback($$v) {
            _vm.$set(menuItem, "hashtag", $$v);
          },
          expression: "menuItem.hashtag"
        }
      })], 1)], 1), _c('b-col', {
        staticClass: "d-flex align-items-end",
        attrs: {
          "cols": "12",
          "lg": "2"
        }
      }, [_c('b-form-checkbox', {
        staticClass: "pb-2",
        on: {
          "change": function change($event) {
            return _vm.persistPageMenus(page.pageKey);
          }
        },
        model: {
          value: menuItem.is_external,
          callback: function callback($$v) {
            _vm.$set(menuItem, "is_external", $$v);
          },
          expression: "menuItem.is_external"
        }
      }, [_vm._v(" 外開連結 ")])], 1)], 1)], 1)]);
    }), _c('div', {
      staticClass: "page-menu-add-btn"
    }, [_c('b-button', {
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.addPageMenuItem(page.pageKey);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-plus mr-1"
    }), _vm._v(" 新增選單項目 ")])], 1)], 2), _c('div', {
      staticClass: "page-content"
    }, [_c('div', {
      staticClass: "page-meta-label mb-1"
    }, [_vm._v("頁面內容")]), _c('classic-editor', {
      attrs: {
        "extra-plugins": [_vm.MyCustomUploadAdapterPlugin]
      },
      model: {
        value: _vm.form[_vm.fullKey(page.pageKey, 'content')],
        callback: function callback($$v) {
          _vm.$set(_vm.form, _vm.fullKey(page.pageKey, 'content'), $$v);
        },
        expression: "form[fullKey(page.pageKey, 'content')]"
      }
    })], 1)]);
  }), _c('div', {
    staticClass: "add-page-btn mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_c('i', {
    staticClass: "mdi mdi-plus mr-1"
  }), _vm._v(" 新增頁面 ")])], 1), _c('b-modal', {
    attrs: {
      "id": "add-liff-page-modal",
      "title": "新增頁面",
      "ok-disabled": !_vm.newPageKey || _vm.newPageKeyDuplicated || !_vm.newPageKeyValid,
      "ok-title": "確認新增",
      "cancel-title": "取消"
    },
    on: {
      "ok": _vm.confirmAddPage,
      "hidden": _vm.resetNewPageKey
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "頁面識別代號 (path_key)",
      "label-size": "sm",
      "description": "僅允許英文小寫、數字與底線，例如：event_page。建立後無法更改。",
      "state": _vm.newPageKeyState,
      "invalid-feedback": _vm.newPageKeyError
    }
  }, [_c('b-input-group', {
    attrs: {
      "append": "_page"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.newPageKeyState,
      "autofocus": ""
    },
    model: {
      value: _vm.newPageKey,
      callback: function callback($$v) {
        _vm.newPageKey = $$v;
      },
      expression: "newPageKey"
    }
  })], 1)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }